import { FaClock, FaMapMarkerAlt, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaHourglass, FaTools, FaUserCog, FaHammer, FaLock, FaKey, FaDoorOpen, FaLockOpen, FaUnlockAlt } from 'react-icons/fa';
import { FaShieldHalved } from 'react-icons/fa6';

// Function to render the appropriate icon based on the name
export const renderIcon = (iconName) => {

  // Convert the name to lowercase
  const lowercaseName = iconName.toLowerCase();

  // Check the lowercase name and return the corresponding icon component
  switch (lowercaseName) {

    /*----- Service Icons -----*/
    case 'lock installation':
      return <FaLock />; // Lock icon

    case 'key duplication':
      return <FaKey />; // Key icon

    case 'lock repair':
      return <FaTools />; // Tools icon

    case 'security consultation':
      return <FaShieldHalved />; // Shield icon

    case 'lockout assistance':
      return <FaDoorOpen />; // Open door icon

    case 'master key':
      return <FaKey />; // Key icon

    /*----- Emergency Service Icons -----*/
    case 'lockout help':
      return <FaLockOpen />; // Unlocked lock icon

    case 'key replacement':
      return <FaKey />; // Key icon

    case 'damage fix':
      return <FaHammer />; // Hammer icon

    case 'safe opening':
      return <FaUnlockAlt />; // Unlock icon

    case 'anytime assistance':
      return <FaClock />; // Clock icon

    /*----- Page Sidebar Icons -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon

    case 'timing':
    case 'hours':
      return <FaClock />; // Clock icon

    case 'duration':
      return <FaHourglass />; // Hourglass icon

    case 'client':
    case 'position':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Map marker icon

    case 'salary':
    case 'cost':
      return <FaDollarSign />; // Dollar sign icon

    case 'experience':
      return <FaBriefcase />; // Briefcase icon

    case 'leadlocksmith':
      return <FaUserCog />; // User settings icon

    case 'number':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Envelope icon

    default:
      return null; // Return null if no matching icon is found
  }

};